(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-section"] && !Shopify.designMode) return;
  try {
    
// Desktop Toggle JavaScript
window.addEventListener('load', function(){
  var root = document.querySelector('.ingredients-section');
  if(!root) return;
  
  var btn = root.querySelector('.ingredients__btn');
  if(!btn) return;
  
  var fade = root.querySelector('.ingredients__fade');
  if(!fade) return;
  
  var hiddenCards = root.querySelectorAll('.is-hidden-row');
  if(hiddenCards.length === 0) return;
  
  var isExpanded = false;
  
  // Arrow SVG
  var arrowSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="21" viewBox="0 0 16 21" fill="none"><path d="M8 19.45L8 1.5M14.5 12.7951L8 19.5L1.5 12.7951" stroke="#05304D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  
  // Arrow beim Laden hinzufügen
  var btnIcon = btn.querySelector('.ingredients__btn-icon');
  if(btnIcon) {
    btnIcon.innerHTML = arrowSvg;
  } else {
    btn.innerHTML = '<span class="ingredients__btn-label">Alle Inhaltsstoffe entdecken</span><span class="ingredients__btn-icon">' + arrowSvg + '</span>';
  }
  
  function toggle(){
    if(isExpanded){
      // Zuklappen - Alles gleichzeitig
      root.classList.remove('is-expanded');
      
      // Karten und Button gemeinsam verstecken
      for(var i = 0; i < hiddenCards.length; i++){
        hiddenCards[i].style.opacity = '0';
        hiddenCards[i].style.transform = 'translateY(-30px)';
      }
      
      // Button gleichzeitig nach oben bewegen
      fade.style.transform = 'translateY(-30px)';
      fade.style.opacity = '0';
      
      setTimeout(function(){
        for(var j = 0; j < hiddenCards.length; j++){
          hiddenCards[j].style.display = 'none';
        }
        fade.style.position = 'absolute';
        fade.style.top = '0';
        fade.style.left = '0';
        fade.style.right = '0';
        fade.style.bottom = '0';
        fade.style.background = 'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 60%, rgba(255,255,255,1) 100%)';
        fade.style.paddingBottom = '55px';
        fade.style.paddingTop = '0';
        fade.style.opacity = '1';
        fade.style.transform = 'translateY(0)';
        fade.style.visibility = 'visible';
      }, 600);
      
      btn.setAttribute('aria-expanded','false');
      btn.querySelector('.ingredients__btn-label').textContent = 'Alle Inhaltsstoffe entdecken';
      
      // Arrow nach unten drehen
      var btnIcon = btn.querySelector('.ingredients__btn-icon');
      if(btnIcon) {
        btnIcon.innerHTML = arrowSvg;
      }
      
      isExpanded = false;
    } else {
      // Aufklappen - Alles gleichzeitig
      root.classList.add('is-expanded');
      
      // Karten und Button gemeinsam anzeigen
      for(var i = 0; i < hiddenCards.length; i++){
        hiddenCards[i].style.display = 'flex';
        hiddenCards[i].style.opacity = '0';
        hiddenCards[i].style.transform = 'translateY(-30px)';
      }
      
      // Button gleichzeitig nach unten bewegen
      fade.style.position = 'static';
      fade.style.background = 'none';
      fade.style.paddingTop = '40px';
      fade.style.paddingBottom = '0';
      fade.style.opacity = '0';
      fade.style.transform = 'translateY(-30px)';
      fade.style.visibility = 'visible';
      
      setTimeout(function(){
        for(var j = 0; j < hiddenCards.length; j++){
          hiddenCards[j].style.opacity = '1';
          hiddenCards[j].style.transform = 'translateY(0)';
        }
        fade.style.opacity = '1';
        fade.style.transform = 'translateY(0)';
      }, 50);
      
      btn.setAttribute('aria-expanded','true');
      btn.querySelector('.ingredients__btn-label').textContent = 'Weniger anzeigen';
      
      // Arrow nach oben drehen
      var btnIcon = btn.querySelector('.ingredients__btn-icon');
      if(btnIcon) {
        btnIcon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="21" viewBox="0 0 16 21" fill="none" style="transform: rotate(180deg);"><path d="M8 19.45L8 1.5M14.5 12.7951L8 19.5L1.5 12.7951" stroke="#05304D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      }
      
      isExpanded = true;
    }
  }
  
  btn.addEventListener('click', function(e){
    e.preventDefault();
    toggle();
  });
});

// Mobile Slider JavaScript - Touch Swipe für beide Slider
window.addEventListener('load', function(){
  // Alle Ingredients-Sektionen finden
  var ingredientsSections = document.querySelectorAll('[id^="ingredients-"]');
  
  ingredientsSections.forEach(function(root){
    var sectionId = root.id.replace('ingredients-', '');
    
    // Funktion zur Initialisierung eines einzelnen Sliders
    function initMobileSlider(sliderId, trackId, dotsId, cardsSelector){
      var mobileSlider = root.querySelector('#' + sliderId);
      if(!mobileSlider) return;
      
      var track = root.querySelector('#' + trackId);
      var dotsContainer = root.querySelector('#' + dotsId);
      
      if(!track || !dotsContainer) return;
      
      var slides = track.querySelectorAll('.ingredients__mobile-slide');
      var currentSlide = 0;
      var startX = 0;
      var currentX = 0;
      var isDragging = false;
      
      // Dots erstellen
      function createDots(){
        dotsContainer.innerHTML = '';
        for(var i = 0; i < slides.length; i++){
          var dot = document.createElement('button');
          dot.className = 'ingredients__mobile-dot';
          if(i === currentSlide) dot.classList.add('active');
          
          // SVG Icon für jeden Dot
          var svgIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none"><circle cx="3.5" cy="3.5" r="3.5" fill="' + (i === currentSlide ? '#05304D' : '#D9D9D9') + '"/></svg>';
          dot.innerHTML = svgIcon;
          
          dot.addEventListener('click', function(index){
            return function(){
              goToSlide(index);
            };
          }(i));
          dotsContainer.appendChild(dot);
        }
      }
      
      // Slide wechseln
      function goToSlide(index){
        currentSlide = index;
        var translateX = -currentSlide * (300 + 20); // 300px Kartenbreite + 20px gap
        track.style.transform = 'translateX(' + translateX + 'px)';
        
        // Dots aktualisieren
        var dots = dotsContainer.querySelectorAll('.ingredients__mobile-dot');
        dots.forEach(function(dot, i){
          dot.classList.toggle('active', i === currentSlide);
          // SVG Icon aktualisieren
          var svgIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none"><circle cx="3.5" cy="3.5" r="3.5" fill="' + (i === currentSlide ? '#05304D' : '#D9D9D9') + '"/></svg>';
          dot.innerHTML = svgIcon;
        });
      }
      
      // Touch Events mit verbessertem Swipe-Verhalten
      var startY = 0;
      var currentY = 0;
      var isHorizontalSwipe = false;
      
      track.addEventListener('touchstart', function(e){
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isDragging = true;
        isHorizontalSwipe = false;
      });
      
      track.addEventListener('touchmove', function(e){
        if(!isDragging) return;
        
        currentX = e.touches[0].clientX;
        currentY = e.touches[0].clientY;
        
        var diffX = startX - currentX;
        var diffY = startY - currentY;
        
        // Bestimmen ob es ein horizontaler oder vertikaler Swipe ist
        if(Math.abs(diffX) > Math.abs(diffY)){
          // Horizontaler Swipe - vertikales Scrollen verhindern
          isHorizontalSwipe = true;
          e.preventDefault();
          e.stopPropagation();
          
          var translateX = -currentSlide * (300 + 20) - diffX;
          track.style.transform = 'translateX(' + translateX + 'px)';
        } else if(Math.abs(diffY) > Math.abs(diffX)){
          // Vertikaler Swipe - horizontales Swipen beenden
          isHorizontalSwipe = false;
          isDragging = false;
        }
      });
      
      track.addEventListener('touchend', function(e){
        if(!isDragging) return;
        isDragging = false;
        
        // Nur bei horizontalem Swipe die Slide-Logik ausführen
        if(isHorizontalSwipe){
          var diffX = startX - currentX;
          var threshold = 50; // Mindest-Swipe-Distanz
          
          if(Math.abs(diffX) > threshold){
            if(diffX > 0 && currentSlide < slides.length - 1){
              // Swipe nach links - nächste Karte
              goToSlide(currentSlide + 1);
            } else if(diffX < 0 && currentSlide > 0){
              // Swipe nach rechts - vorherige Karte
              goToSlide(currentSlide - 1);
            } else {
              // Zurück zur aktuellen Position
              goToSlide(currentSlide);
            }
          } else {
            // Zurück zur aktuellen Position
            goToSlide(currentSlide);
          }
        }
        
        isHorizontalSwipe = false;
      });
      
      // Karten auf gleiche Höhe bringen
      function equalizeCardHeights(){
        var cards = track.querySelectorAll(cardsSelector);
        var maxHeight = 0;
        
        // Erst alle Karten auf natürliche Höhe zurücksetzen
        cards.forEach(function(card){
          card.style.height = 'auto';
        });
        
        // Höchste Karte finden
        cards.forEach(function(card){
          var cardHeight = card.offsetHeight;
          if(cardHeight > maxHeight){
            maxHeight = cardHeight;
          }
        });
        
        // Alle Karten auf die höchste Höhe setzen
        cards.forEach(function(card){
          card.style.height = maxHeight + 'px';
        });
      }
      
      // Initialisierung
      createDots();
      goToSlide(0);
      
      // Höhen angleichen nach dem Laden
      setTimeout(equalizeCardHeights, 100);
    }
    
    // Beide Slider für diese Sektion initialisieren
    initMobileSlider('ingredients-mobile-featured-' + sectionId, 
                     'ingredients-track-featured-' + sectionId, 
                     'ingredients-dots-featured-' + sectionId,
                     '.ing-card--mobile-featured');
    
    initMobileSlider('ingredients-mobile-standard-' + sectionId, 
                     'ingredients-track-standard-' + sectionId, 
                     'ingredients-dots-standard-' + sectionId,
                     '.ing-card--mobile-standard');
    
    // Tab Navigation initialisieren
    var tabContainer = root.querySelector('#ingredients-mobile-tabs-' + sectionId);
    if(tabContainer){
      var tabs = tabContainer.querySelectorAll('.ingredients__mobile-tab');
      var featuredSlider = root.querySelector('#ingredients-mobile-featured-' + sectionId);
      var standardSlider = root.querySelector('#ingredients-mobile-standard-' + sectionId);
      
      tabs.forEach(function(tab){
        tab.addEventListener('click', function(){
          var tabType = this.getAttribute('data-tab');
          
          // Alle Tabs deaktivieren
          tabs.forEach(function(t){
            t.classList.remove('ingredients__mobile-tab--active');
          });
          
          // Alle Slider verstecken
          if(featuredSlider) featuredSlider.classList.remove('ingredients__mobile-slider--active');
          if(standardSlider) standardSlider.classList.remove('ingredients__mobile-slider--active');
          
          // Aktiven Tab markieren
          this.classList.add('ingredients__mobile-tab--active');
          
          // Entsprechenden Slider anzeigen
          if(tabType === 'featured' && featuredSlider){
            featuredSlider.classList.add('ingredients__mobile-slider--active');
          } else if(tabType === 'standard' && standardSlider){
            standardSlider.classList.add('ingredients__mobile-slider--active');
          }
        });
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
